import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicationsComponent } from './communications.component';
import { StoreModule } from '@ngrx/store';
import { CommunicationsReducers, STORE_FEATURE_KEY_COMMUNICATION } from './state/communications.reducer';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            STORE_FEATURE_KEY_COMMUNICATION,
            CommunicationsReducers
        ),
        TranslateModule
    ],
    declarations: [
        CommunicationsComponent
    ]
})
export class CommunicationsModule {

}